import { ItemBID } from '../Types/ItemBID';
import { get } from './http';

export const getItemBIDs = async (articleNumber: string) => {
  try {
    const res = await get(`/api/itembids/${articleNumber}`);
    return (await res.json()) as ItemBID[];
  } catch (err) {
    if (err.response?.status == 404) {
      return undefined;
    }
    throw err;
  }
};
